<script lang="ts" setup>
import OrganizationAvatar from '@/components/utilities/OrganizationAvatar.vue'
import CreateOrganization from '@/components/utilities/CreateOrganization.vue'
import type { Organization } from '@/stores/auth/Auth'
import {
    useIsActiveOrganization,
    useOrganizations,
    useAuth,
    useActiveOrganization
} from 'auth-package'
import { watchEffect } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const organizations = useOrganizations()
const activeOrganization = useActiveOrganization()
const route = useRoute()
const router = useRouter()

// const selectOrganization = (organization: Organization) => {
//     useAuth().setActiveOrganization(organization)
// }

const selectOrganization = (organization: Organization) => {
    useAuth().setActiveOrganization(organization)
    const allowedPaths = new Set([
        '/settings/account',
        '/settings/organization',
        '/settings/organization/members'
    ])
    const redirectPath = '/campaign-manager/list/active'
    if (!allowedPaths.has(route.path) && route.path !== redirectPath) {
        router.push(redirectPath)
    }
}

watchEffect(() => {
    const organizationIds = Object.keys(organizations.value)
    if (organizationIds.length >= 1 && !activeOrganization.value) {
        const organization = organizations.value[organizationIds[0]]
        useAuth().setActiveOrganization(organization)
    }
})
</script>

<template>
    <aside class="el-aside organization-list">
        <el-scrollbar height="100vh">
            <div
                class="organization"
                v-for="(organization, organizationId) in organizations"
                :key="organizationId"
                :class="{ isActive: useIsActiveOrganization(organization).value }"
                @click="selectOrganization(organization)"
            >
                <OrganizationAvatar
                    :isActive="useIsActiveOrganization(organization).value"
                    :organization="organization"
                />
            </div>
            <div class="organization">
                <CreateOrganization />
            </div>
        </el-scrollbar>
    </aside>
</template>

<style lang="scss" scoped>
.organization-list {
    // border-right: solid 1px var(--el-border-color-light);
    margin: 0;
    padding-left: 0;
    background-color: var(--el-bg-color-page);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 66px;

    .organization {
        width: 62px;
        height: 62px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 0;
        background: var(--el-bg-color-page);

        &:first-child {
            margin-top: 0;
        }

        &.isActive {
            background-color: var(--el-menu-hover-bg-color);
        }

        &:hover {
            background-color: var(--el-menu-hover-bg-color);

            .el-avatar {
                border: solid 3px var(--el-border-color-darker);
            }
        }

        &.isActive {
            background-color: var(--el-menu-hover-bg-color);

            .el-avatar {
                //border: solid 3px var(--el-color-info-dark-2);
                //padding:3px;
                border: solid 3px var(--el-color-primary);
            }
        }
    }
}
</style>
